import React, { useState } from 'react';
import styles from './index.module.scss';
import { ITelephones } from '../../interfaces/CaseDetail.type';
import PhoneNumberContactCard from '@cp/pages/CaseDetails/components/PhoneNumber/PhoneNumberContactCard';

const CustomerDeviceData: React.FC<ITelephones> = props => {
  const { data = [] } = props;

  return (
    <div className={styles.customerDeviceContainer}>
      {data?.map(callData => (
        <PhoneNumberContactCard key={callData.number} callData={callData} />
      ))}
    </div>
  );
};

export default CustomerDeviceData;
